import Vue from 'vue'
import videojs from 'video.js'
import BootstrapVue from 'bootstrap-vue'
import VueVideoPlayer from 'vue-video-player'
import VueLazyload from 'vue-lazyload-img'
import VueScrollto from 'vue-scrollto'
import Vuebar from 'vuebar'
import router from './router'
import store from './store'
import App from './App.vue'

// directives
import { HoverIntent } from './directives'

// styles
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'
import 'video.js/dist/video-js.css'
import '@/scss/style.scss'

window.Vue = Vue

Vue.config.devtools = true
// Vue.use( Vuex )
Vue.use( BootstrapVue )
Vue.use( VueVideoPlayer )
Vue.use( VueLazyload, { fade: true })
Vue.use( VueScrollto )
Vue.use( Vuebar )

Vue.directive( 'hover-intent', HoverIntent )

window.store = store
window.videojs = videojs
videojs.log.level( 'debug' )

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h( App )
}).$mount('#app')
